import { Action } from '@ngrx/store';

export enum TreatmentSelectionActionsTypes {
  UPDATE_SELECTED_TREATMENT = '[Bpmn Process] Update selected treatment'
}

export class UpdateSelectedTreatment implements Action {
  readonly type = TreatmentSelectionActionsTypes.UPDATE_SELECTED_TREATMENT;
  constructor(public payload: { selectedTreatmentActivityId: string}) { }
}

export type TreatmentSelectionActions = UpdateSelectedTreatment;
